<template>
    <div class="release">
        <div class="main">
            <!-- 筛选 -->
            <el-radio-group v-model="radio">
                <el-radio :label="1">电商商品</el-radio>
                <el-radio :label="2">本地生活</el-radio>
            </el-radio-group>
            <el-button size="medium" type="primary" style="display: block; margin-top: 30px" @click="treeShow">选择商品分类</el-button>
            <div class="form">
                <el-form ref="form" :model="form" inline>
                    <el-form-item label="商品名称：">
                        <el-input v-model="form.name" clearable></el-input>
                    </el-form-item>
                    <el-form-item label="分类：">
                        <el-cascader v-model="form.type" :options="treeData" :props="props" clearable @change="handleChange"></el-cascader>
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button size="medium" type="primary" style="display: inline-block" @click="initList">搜索</el-button>
                        <el-button size="medium" style="display: inline-block" @click="remove">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <!-- 表格 -->
            <div class="table">
                <el-table :data="tableData" border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange" v-loading="load">
                    <el-table-column type="selection" width="55" v-if="!isCheck"> </el-table-column>
                    <el-table-column prop="id" label="商品ID"> </el-table-column>
                    <el-table-column prop="imgs_mains" label="商品图片">
                        <template slot-scope="scope">
                            <el-image :src="scope.row.imgs_mains" style="width: 60px; height: 60px"></el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="tits" label="商品名称"> </el-table-column>
                    <el-table-column prop="goods_classifys_relation_str" label="商品分类">
                        <template slot-scope="scope">
                            {{ strFormat(scope.row.goods_classifys_relation_str) }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="merchandise_inventory" label="库存"> </el-table-column>
                    <el-table-column prop="prices_defaults" label="销售价（元）"> </el-table-column>
                </el-table>
            </div>
            <!-- 加入商品 -->
            <div style="margin-top: 20px; padding-left: 0px; display: flex">
                <!-- <el-button type="primary" size="medium" style="margin-right: 20px"
          >加入我的商品</el-button
        > -->
                <div class="alertBox" v-if="!isCheck">
                    <p>
                        <i class="el-icon-warning"></i>已选择<span>{{ multipleSelection.length }}</span
                        >项
                    </p>
                    <el-link type="primary" @click="toggleSelection()">清空</el-link>
                </div>
            </div>
            <!-- 分页 -->
            <div class="pageSize">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="pageSizes"
                    :page-size="limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                >
                </el-pagination>
            </div>
            <div class="btnList">
                <el-button size="medium" @click="back">{{ !isCheck == 0 ? "取消" : "返回" }}</el-button>
                <el-button size="medium" @click="save" v-if="!isCheck">保存</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from "vuex";
export default {
    data() {
        return {
            load: false,
            page: 1,
            limit: 10,
            pageSizes: [10, 20, 30, 40],
            total: 0,
            form: {
                name: "",
                type: null,
            },
            radio: 1,
            rules: {},
            props: {
                expandTrigger: "hover",
                children: "children",
                label: "name",
                value: "id",
            },
            tableData: [],
            multipleSelection: [],
            cList: this.checkedList,
        };
    },
    props: ["treeData", "checkedList", "goods_mains_ids", "isCheck"],
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    created() {
        this.initList();
        // console.log(this.goods_mains_ids);
        // console.log(this.isCheck,"ce");
    },
    methods: {
        ...mapActions({
            getGoodsList: "commodity/getGoodsList",
        }),
        bind(list) {
            this.cList = list;
        },
        treeShow() {
            this.$emit("treeShow");
        },
        strFormat(val) {
            return val.replace(/,/g, ">");
        },
        remove() {
            this.form.name = "";
            this.form.type = null;
            this.initList(1);
        },
        handleChange(val) {
            this.initList();
        },
        async initList(tag) {
            // console.log(this.cList);
            try {
                this.load = true;
                if (tag == 1) {
                    this.page = 1;
                }
                let opt = {
                    token: this.getToken, //商家验证token
                    filter: {
                        //非必填项   搜索条件
                        status: 1, //商品状态  1 已上架   0 下架
                        classifys_type_id: 2000, //商品分类类型   2000 实体商品   2001 虚拟商品
                        // sorts_tops: 1, //商品一级分类id
                        _like_tits: this.form.name ? this.form.name : null,
                    },
                    is_coupon: 1,
                    // orderby: "sales_nums desc, prices_defaults asc", //非必填， 排序规则
                    offset: (this.page - 1) * this.limit,
                    limit: this.limit,
                };
                if (this.isCheck) {
                    opt.filter._in_id = this.goods_mains_ids.split(",").map((v) => {
                        return Number(v);
                    });
                }
                if (this.form.type && this.form.type.length != 0) {
                    opt.filter._in_sorts = [this.form.type[2]];
                } else {
                    if (this.cList && this.cList.length != 0) {
                        opt.filter._in_sorts = this.cList;
                    }
                }

                let res = await this.getGoodsList(opt);
                // console.log(res, "res");
                if (res.code != 1) {
                    return this.$message.error(res.msg);
                }
                this.tableData = res.data.list;
                this.total = res.data.count ? Number(res.data.count) : 0;
            } catch (err) {
                console.log(err);
            } finally {
                this.load = false;
            }
        },

        back() {
            this.$emit("closeDia");
        },
        save() {
            this.$emit("getIdList", this.multipleSelection);
            this.$message.success("商品关联成功！");
        },
        toggleSelection(rows) {
            if (rows) {
                rows.forEach((row) => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = [];
            if (val && val.length != 0) {
                val.forEach((item) => {
                    this.multipleSelection.push(item.id);
                });
            }
        },
        // 每页显示数据条数
        handleSizeChange(val) {
            this.limit = val;
            this.initList();
        },
        // 当前页改变
        handleCurrentChange(val) {
            this.page = val;
            this.initList();
        },
    },
};
</script>

<style lang='scss' scoped>
.btnList {
    margin-top: 40px;
    display: flex;
    justify-content: center;
    .el-button {
        width: 100px;
        margin: 0 20px;
    }
}
.release {
    .title {
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        font-size: 20px;
        align-items: center;
        a {
            text-decoration: none;
        }
        p {
            font-size: 20px;
            color: #000000;
            margin-left: 0;
        }
    }
    .main {
        background: #fff;
        margin-top: 24px;
        max-height: 650px;
        overflow-y: auto;
        padding-right: 20px;
        .form {
            margin-top: 40px;
        }
    }
}
.alertBox {
    height: 40px;
    background: #e6f7ff;
    border: 1px solid #bae7ff;
    width: 100%;
    border-radius: 3px;
    padding: 0 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
        color: #666;
        i {
            display: inline-block;
            color: #1890ff;
            margin-right: 4px;
        }
        span {
            margin: 0 4px;
            color: #1890ff;
        }
    }
}
.pageSize {
    text-align: right;
    margin-top: 20px;
}
</style>